import {
    GET_TOURS,
    GET_TOUR,
    BOOK_TOUR,
    SET_LOADING,
    GET_PAYMENT_INFO_TOUR,
    SAVE_USER_BOOKING
} from '../actions/types';

const initialState = {
    tours: [],
    tour: {
        // location: {
        //     latitude: 0,
        //     longitude: 0
        // },
        pricing: {},
        bookings: [],
        photos: []
    },
    highSeason: false,
    bookingIds: {},
    loading: false
};

export default function (state = initialState, action) {
    switch (action.type) {
        case SET_LOADING:
            return {
                ...state,
                loading: true
            };
        case GET_TOURS:
            return {
                ...state,
                tours: action.payload,
                loading: false
            };
        case GET_TOUR:
            return {
                ...state,
                tour: action.payload,
                loading: false
            };
        case BOOK_TOUR:
            return {
                ...state,
                bookingIds: action.payload
            };
        case GET_PAYMENT_INFO_TOUR:
            return {
                ...state,
                paymentInfo: action.payload
            };
        case SAVE_USER_BOOKING:
            return {
                ...state,
                bookingResult: action.payload
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/toursReducer.js